import Helpers from '@common/helpers/helperFunctions';

export const fields = [
  {
    name: 'CNP',
    fieldName: 'CNP',
    isFieldValid: (value) => Helpers.validateCNP(value),
    errorMessage: 'CNP is not correct or You need to be over 18',
  },
  {
    name: 'Name',
    fieldName: 'Name',
    isFieldValid: (value) => value.length > 2 && /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i.test(value),
    errorMessage: 'Contain at least 3 charachters and only letter',
  },
  {
    name: 'Surname',
    fieldName: 'Surname',
    isFieldValid: (value) => value.length > 2 && /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i.test(value),
    errorMessage: 'Contain at least 3 charachters and only letter',
  },
];
